import * as Actions from '../Actions/CIDActions';
// import _ from '@lodash';

const initialState = {
    data: null,
};

const CIDReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_CID:
            {
                return {
                    ...state,
                    data: action.payload,
                };
            }
        case Actions.ERROR_CID:
            {
                return {
                    ...state,
                    success: false,
                    CIDDialog: {
                        props:
                        {
                            open: true,
                            error: action.payload
                        },
                        data: null
                    }
                };
            }
        case Actions.CID_INFO:
            {
                return {
                    ...state,
                    success: true,
                    CIDDialog: {
                        props:
                        {
                            open: true,
                            info: action.payload
                        },
                        data: null
                    }
                };
            }
        case Actions.CID_WARNING:
            {
                return {
                    ...state,
                    success: true,
                    CIDDialog: {
                        props:
                        {
                            open: false,
                            warning: action.payload
                        },
                        data: null
                    }
                };
            }
        default:
            {
                return state;
            }
    }
};

export default CIDReducer;
